import { useState, forwardRef, useImperativeHandle } from 'react';
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import strFunc from '@/lib/lyg/string';
const ListSearchComponent = forwardRef((props: any, ref) => {
  let myProps: any = {
    "categoryInfoArr": [],
    "listOpt": {
      "s_state": "",
      "s_category_seq": ""
    },
    "xColumnArr": {
      "x_column_list_arr": []//[{"key":"a_ymd","name":"board_ymd","width":"100","is_show":"1"}]
    },
    "list": () => { },
    ...props
  };
  const [categoryInfoArr, setCategoryInfoArr] = useState(myProps.categoryInfoArr);
  let listOpt = myProps.listOpt;
  let select_state_arr = XcolumnFunc.getSortByTableKey({ 'table': 'video_corse', 'key': 'a_state' });

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    setCategoryInfoArr
  }));

  let goSearch = (inOptObj: any) => {
    let optObj = {
      "key": "",
      "value": "",
      ...inOptObj
    };
    if (optObj["key"] == "") {
      return false;
    }
    let key = optObj["key"];
    let value = optObj["value"];
    let change_list_opt: any = {
      now_page: 1,
    };
    change_list_opt[key] = value;
    myProps.list(change_list_opt);
  };

  return (
    <div>
      <div style={{ position: "relative" }}>
        <h4>강의리스트</h4>
        <div style={{ "position": "absolute", right: 0, top: 0 }}>
          {strFunc.is_empty(listOpt.s_stu_seq) &&
            <span className='ml-1'>
              <label>
                <input type='checkbox' name="s_open_group" value=""
                  checked={listOpt.s_open_group == "main"}
                  onChange={(e: any) => {
                    let value = e.target.checked ? "main" : "";
                    goSearch({
                      "key": "s_open_group",
                      "value": value
                    });
                  }} />
                <span className='ml-1'>공통</span>
              </label>
            </span>
          }
          <select className="search-input_select ml-1" value={listOpt.s_state}
            onChange={(e: any) => {
              goSearch({
                "key": "s_state",
                "value": e.target.value
              });
            }}
            style={{ maxWidth: 100 }}
          >
            <option value="">상태</option>
            {
              select_state_arr.map((item: any, idx: number) => {
                return (
                  <option value={item.value} key={idx}>{item.text}</option>
                );
              })
            }
          </select>
          <select className="search-input_select ml-2" value={listOpt.s_category_seq}
            onChange={(e: any) => {
              goSearch({
                "key": "s_category_seq",
                "value": e.target.value
              });
            }}
            style={{ maxWidth: 120 }}
          >
            <option value="">카테고리</option>
            {
              categoryInfoArr.map((item: any, idx: number) => {
                return (
                  <option value={item.a_seq} key={idx}>{item.a_title}</option>
                );
              })
            }
          </select>
        </div>
      </div>
    </div>
  );
});

export default ListSearchComponent;